import React from 'react'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import Countuppage1 from './Countuppage1'
import Countuppage2 from './Countuppage2'
import Countuppage3 from './Countuppage3'
import Countuppage4 from './Countuppage4'



function Banner(){
 
    return (
    <>
  <div>
  <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
    <div className="carousel-inner">
      <div className="carousel-item active">
        <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/09/Banner1-scaled.jpg" className="d-block w-100" alt="..." />
      </div>
      <div className="carousel-item">
        <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/12/Banner3-1.jpg" className="d-block w-100" alt="..." />
      </div>
      <div className="carousel-item">
        <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/12/Banner4-1.jpg" className="d-block w-100" alt="..." />
      </div>
    </div>
  </div>          
  <div className="details text-center">
    <p>Established in 2002, Smile Foundation is an Indian development organization, impacting the lives of over 15 lakh children and their families every year. We have more than 400 projects on education, healthcare, livelihood, and women empowerment in over 2,000 remote villages and urban slums across 25 states of India.</p>
    <p>Smile Foundation works as a catalyst in the cycle of change, complementing and supplementing government efforts. We sensitize and partner with like-minded institutions and individuals to bring sustainable change at the grassroots, by enabling access, enhancing quality and bringing long term behavioural change within the communities.</p>  
    <a className='link-brand' href>read more &gt;</a> 
  </div>  
  <div className="our-impact text-center">
    <h2 className="bold-1  ">OUR IMPACT</h2>
    <div className="conatiner">
      <div className="row  justify-content-center">
        <div className="col-lg-3">
          <Countuppage1/>
          <h2 className="bold-3">LAC </h2> 
          <p>children and <br />
            their families are<br />
            impacted every year</p> 
        </div>
        <div className="col-lg-3">
          <Countuppage2/>
          <h2 className="bold-3">VILLAGES</h2> 
          <p>and slums<br />
            are reached out<br />
            to across the country </p> 
        </div>
        <div className="col-lg-3">
          <Countuppage3/>
          <h2 className="bold-3">PROJECTS</h2> 
          <p>focused on<br />
            education, healthcare,<br />
            and women empowerment</p> 
        </div>
        <div className="col-lg-3">
          <Countuppage4/>
          <h2 className="bold-3">STATES</h2> 
          <p>are reached<br />
            including the<br />
            remotest areas</p> 
        </div>
      </div>
    </div>
  </div> 
  <div className="filedofchange ">
    <h2 className="bold-1 text-center">FIELDS OF CHANGE</h2> 
    <div className="container  ">
      <div className="row">
        <div className="col-lg-6 py-4">
          <div className="row">
            <div className="col-lg-2 py-4">
              <img className='w1' src={require('../Image/Desktop-Version-1.png')} />
            </div>
            <div className="col-lg-10 py-4 ctr">
              <h2 className=" bold-12"> <u>EDUCATION</u> </h2>
              <p className=" bold-13">Education, nutrition and holistic development of children</p>
            </div>
          </div> 
        </div>
        <div className="col-lg-6 py-4">
          <div className="row">
            <div className="col-lg-2 py-4">
            <img className='w1' src={require('../Image/Desktop-Version-2.png')} />
            </div>
            <div className="col-lg-10 py-4 ctr ">
              <h2 className=" bold-21"><u>HEALTHCARE</u></h2>
              <p className=" bold-13">Taking healthcare services to doorsteps of hard to reach communities </p>
            </div>
          </div> 
        </div>
      </div>
    </div>
    <div className="container  ">
      <div className="row">
        <div className="col-lg-6 py-4">
          <div className="row">
            <div className="col-lg-2 py-4">
            <img className='w1' src={require('../Image/Desktop-Version-3.png')} />
            </div>
            <div className="col-lg-10 py-4 ctr ">
              <h2 className=" bold-31 "><u>WOMEN EMPOWERMENT</u></h2>
              <p className=" bold-13">Empowering adolescent girls &amp; women through community engagement</p>
            </div>
          </div> 
        </div>
        <div className="col-lg-6 py-4">
          <div className="row">
            <div className="col-lg-2 py-4">
            <img className='w1' src={require('../Image/Desktop-Version-4.png')} />
            </div>
            <div className="col-lg-10 py-4 ctr ">
              <h2 className=" bold-41"><u>LIVELIHOOD</u></h2>
              <p className=" bold-13">Skill training and placement support for underprivileged youth</p>
            </div>
          </div> 
        </div>
      </div>
    </div>
  </div>
  <div className="supportacause py-4">
    <h4 className='bold-11 text-center'>TOWARDS ACHIEVING </h4>
    <h3 className="bold-111 text-center ">SUSTAINABLE DEVELOPMENT GOALS </h3>
  </div>
  <div className='container imgcon py-4'>
      <div className='row'>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/good-health.png' /> </div>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/gender-equality.png' /> </div>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/quality-education-copy.png' /> </div>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/economic-growth.png' /> </div>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/reduced-copy.png' /> </div>
          <div className='col-lg-2'><img className='w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/partnership.png' /> </div>
      </div>
  </div>
  <div className='container-sm py-4'>
  <div id="carouselExampleIndicators" className="carousel slide">
  <h2 className='text-uppercase bold-1 py-4 text-center'>stories in motion</h2>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={1} aria-label="Slide 2" />
                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={2} aria-label="Slide 3" />
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className='row'>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/Shiksha-Na-Ruke-Anthem.jpg'/>
                      <a href='https://www.youtube.com/watch?v=gX14MI97aIY' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/8-WorldHealthDay-YouTube-1.png'/>
                      <a href='https://www.youtube.com/watch?v=kvjnlO24wY0&t=40s' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/8-Rupali-Paraja-%E2%80%93-Mission-Education-Beneficiary-Darigabadi-Odisha-YouTube-1.png'/>
                      <a href='https://www.youtube.com/watch?v=Fo1jI_7gJkI' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item ">
                  <div className='row'>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/8-Shiksha-Na-Ruke-for-the-children-of-sugarcane-cutters-in-Beed-Maharashtra-YouTube-1.png'/>
                      <a href='https://www.youtube.com/watch?v=xnGBjj9d0Zo' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/1-WorldHealthDay-YouTube-1.png'/>
                      <a href='https://www.youtube.com/watch?v=kvjnlO24wY0&t=4s' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                    <div className='col-lg-4'>
                      <div className='container'>
                      <img className='d-block d-block1 w-100' src='https://www.smilefoundationindia.org/wp-content/uploads/2023/02/1-Smile-Foundation-s-Real-Work-Real-Change-to-support-the-underprivileged-people-YouTube-1.png'/>
                      <a href='https://www.youtube.com/watch?v=JHUJyXdSavs&t=2s' target="_blank"><i class="bi bi-play-circle"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                <span className="carousel-control-prev-icon carousel-icon" aria-hidden="true" />
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                <span className="carousel-control-next-icon carousel-icon" aria-hidden="true" />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
  </div>
  <div className='container sAc py-4 text-center'>
    <h1 className='bold-1 text-uppercase'>Support A Cause</h1>
            <div class="owl-carousel">
              <div className='img-scale'> 
                <img src='https://www.smilefoundationindia.org/wp-content/uploads/2022/09/Tayyari-Kal-Ki-1-e1662546538529.png' />
                <p className='img-scale2 py-3'>Our campaign ‘Tayyari Kal Ki’ aims at Training & Up Skilling the youth between the age of 18-32 years for employment and empowering them with a secure livelihood.
                <br/>
                <br/>
                <a className='link-success'>know more &#62;</a>
                </p>
                
              </div>
              <div className='img-scale'> 
                <img src='https://www.smilefoundationindia.org/wp-content/uploads/2022/09/Health-Cannot-Wait-2-e1662546609209-1.png' />
                <p className='img-scale2 py-3'>Realising the need for accessible and quality healthcare for all, our campaign ‘Health Cannot Wait’ aims at providing people from the under-privileged sections<br/>
                <br/>
                <a className='link-success'>know more &#62;</a></p>
              </div>
              <div className='img-scale'> 
                <img src='https://www.smilefoundationindia.org/wp-content/uploads/2022/09/Shiksha-na-ruke-1-e1662546701472-1.png' />
                <p className='img-scale2 py-3'>Smile Foundation, through its ‘Shiksha Na Ruke’ initiative, has been helping children from difficult circumstances get back to school and restart their lives<br/>
                <br/><br/>
                <a className='link-success'>know more &#62;</a></p>
              </div>
              <div className='img-scale '> 
                <img src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/sHE-cAN-fLY-1.jpg' />
                <p className='img-scale2 py-3'>Smile Foundation’s initiative ‘She Can Fly’ is an effort to enable, equip and empower girl children with quality education, proper nutrition, good health<br/>
                <br/>
                <br/>
                <a className='link-success'>know more &#62;</a></p>
              </div>
              
            </div>

    </div>         
<div className='lastdetail py-4'>
      <h1 className='bold-1 text-uppercase text-center'>OUR PARTNERS IN CHANGE</h1>       
      <div id="carouselExampleSlidesOnly" class="carousel slide" data-interval="4000" data-bs-ride="carousel">
 <div className="carousel-inner">
  <div className="carousel-item active">
    <div className='row'>
        <div className='col-lg-7 colr1 '>
          <h1 className='text-uppercase'>COVID Management Initiative <br/> of the Year (India) at <br/> Healthcare Asia Awards</h1>
          <p className='px-4'>Smile Foundation’s extensive and multi-pronged effort during the coronavirus pandemic in India was recognized as the COVID Management Initiative of the Year at the Healthcare Asia Awards 2022</p>
          <br/>
          <br/>
          <a className='link-success1'>View all &#62;</a>
        </div>
        <div className='col-lg-5 '>
          <img className='imag-1' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/10.jpg'/>
        </div>
    </div>
  </div>
  <div className="carousel-item ">
    <div className='row'>
        <div className='col-lg-7 colr1 '>
          <h1 className='text-uppercase'>Business World Social Impact  <br/> Leadership award to<br/> Co-Founder </h1>
          <p className='px-4'>Smile Foundation’s Co-Founder and Executive Trustee Mr. Santanu Mishra was recognised for his contribution towards bringing sustainable change in the lives of less privileged children and families through Smile Foundation.</p>
          <br/>
          <br/>
          <a className='link-success1'>View all &#62;</a>
        </div>
        <div className='col-lg-5 '>
          <img className='imag-1' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/6-2.jpg'/>
        </div>
    </div>
  </div>
  <div className="carousel-item ">
    <div className='row'>
        <div className='col-lg-7 colr1 '>
          <h1 className='text-uppercase'>CSR Health Impact Award 2022  <br/> to Smile on Wheels</h1>
          <p className='px-4'>Smile Foundation has been recognised for its healthcare initiative Smile on Wheels for delivering primary healthcare services to vulnerable communities even in the most challenging times by the CSR Health Impact Awards 2022.</p>
          <br/>
          <br/>
          <a className='link-success1'>View all &#62;</a>
        </div>
        <div className='col-lg-5 '>
          <img className='imag-1' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/9.jpg'/>
        </div>
    </div>
  </div>
  <div className="carousel-item ">
    <div className='row'>
        <div className='col-lg-7 colr1 '>
          <h1 className='text-uppercase'>CHeroes Behind the Heroes <br/>  award by Sony Yay</h1>
          <p className='px-4'>Sony Yay conferred Smile Foundation with the prestigious award under the category ‘Heroes Behind The Heroes’ for exemplary work in social welfare during the pandemic.</p>
          <br/>
          <br/>
          <a className='link-success1'>View all &#62;</a>
        </div>
        <div className='col-lg-5 '>
          <img className='imag-1' src='https://www.smilefoundationindia.org/wp-content/uploads/2022/12/8-2.jpg'/>
        </div>
    </div>
  </div>

 
</div>

</div>








</div>
<div className='p-4 container-fluid last1'>
    <h1 className='bold-1 text-uppercase text-center'>Empanelment & Accreditations</h1>  
        <div className="owl-carousel">
            <div> 
                  <div className="card" style={{width: '18rem', height:'25rem'}}>
                    <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/09/IMG_8331-1-768x564.jpg" className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">Smile Foundation has been accredited as a Guidestar India Platinum</h5>
                      <p className="card-text">The accreditation recognizes and verifies the transparency and public accountability of organizations.</p>
                    </div>
                  </div>
              </div>
            <div> 
                  <div className="card" style={{width: '18rem' , height:'25rem'}}>
                    <img style={{ height:'13rem'}} src="https://www.smilefoundationindia.org/wp-content/uploads/2022/12/caf.png" className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">Smile Foundation has been accredited as a Charities Aid Foundation (CAF) America</h5>
                      <p className="card-text">The validation is extended to organizations on basis of a 100 point due diligence review,</p>
                    </div>
                  </div>
              </div>
            <div> 
                  <div className="card" style={{width: '18rem', height:'25rem'}}>
                    <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/12/ecosoc_chamber-1.jpg" className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">Special Consultative Status with the United Nations Economic and Social Council</h5>
                      <p className="card-text">Organization in Special Consultative Status with the United Nations Economic and Social Council (ECOSOC) since 2012</p>
                    </div>
                  </div>
              </div>
            <div> 
                  <div className="card" style={{width: '18rem', height:'25rem'}}>
                    <img src="https://www.smilefoundationindia.org/wp-content/uploads/2022/12/dfltpict-1-768x497.jpg" className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">Smile Foundation has been accredited as a GlobalGiving validated charity</h5>
                      <p className="card-text">GlobalGiving is the largest global crowdfunding community that connects nonprofits</p>
                    </div>
                  </div>
              </div>


        </div>
<br/>
<br/>
      <div className='last1 text-center'><a className='link-success py-4 '>Know more &#62;</a></div>
      

</div>







</div>
    </>
  )
}

export default Banner